import { Component } from 'react';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';

class InfoCard extends Component {
    constructor(props) {
        super(props);
        this.state = { generatingPdf: false };
    }

    downloadPDF = async () => {
        this.setState({ generatingPdf: true });

        const btns = document.querySelectorAll('.btn-pdf-download');
        btns.forEach(b => (b.style.display = 'none'));

        try {
            const allAreas = this.props.allAreas || [this.props.selectedArea];

            const pdf = new jsPDF('p', 'mm', 'a4');
            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight();
            const margin = 12;
            const colGap = 6;
            const colWidth = (pageWidth - margin * 2 - colGap) / 2;

            for (let areaIndex = 0; areaIndex < allAreas.length; areaIndex++) {
                const area = allAreas[areaIndex];

                if (areaIndex > 0) pdf.addPage();

                const shapeName = isNaN(area.name)
                    ? area.name
                    : `${area.type.split(' ')[0]} ${area.name}`;

                pdf.setFontSize(14);
                pdf.setFont('helvetica', 'bold');
                pdf.text(shapeName, margin, 14);

                pdf.setFontSize(11);
                pdf.setFont('helvetica', 'bold');
                pdf.text('Tipo da busca:', margin, 24);
                pdf.setFont('helvetica', 'normal');
                pdf.text(area.type.toLowerCase(), margin + 34, 24);

                pdf.setFont('helvetica', 'bold');
                pdf.text('Total de usuários:', margin, 32);
                pdf.setFont('helvetica', 'normal');
                pdf.text(String(area?.users?.length || 0), margin + 44, 32);

                pdf.setFont('helvetica', 'bold');
                pdf.text('Total de empreendimentos:', margin, 40);
                pdf.setFont('helvetica', 'normal');
                pdf.text(String(area?.buildings?.length || 0), margin + 64, 40);

                pdf.setDrawColor(200, 200, 200);
                pdf.line(margin, 44, pageWidth - margin, 44);

                const chartItems = document.querySelectorAll(`.geo-chart-item[data-area-id="${area.id}"]`);
                let yPos = 50;

                for (let i = 0; i < chartItems.length; i += 2) {
                    const canvas1 = await html2canvas(chartItems[i], { scale: 2, useCORS: true, backgroundColor: '#ffffff' });
                    const img1 = canvas1.toDataURL('image/jpeg', 0.92);
                    const h1 = (canvas1.height * colWidth) / canvas1.width;

                    const hasRight = i + 1 < chartItems.length;
                    let h2 = 0, img2 = null;
                    if (hasRight) {
                        const canvas2 = await html2canvas(chartItems[i + 1], { scale: 2, useCORS: true, backgroundColor: '#ffffff' });
                        img2 = canvas2.toDataURL('image/jpeg', 0.92);
                        h2 = (canvas2.height * colWidth) / canvas2.width;
                    }

                    const rowHeight = Math.max(h1, h2 || 0);

                    if (yPos + rowHeight > pageHeight - margin) {
                        pdf.addPage();
                        pdf.setFontSize(10);
                        pdf.setFont('helvetica', 'italic');
                        pdf.text(`${shapeName} (continuação)`, margin, 10);
                        pdf.line(margin, 13, pageWidth - margin, 13);
                        yPos = 18;
                    }

                    pdf.addImage(img1, 'JPEG', margin, yPos, colWidth, h1);
                    if (hasRight) {
                        pdf.addImage(img2, 'JPEG', margin + colWidth + colGap, yPos, colWidth, h2);
                    }
                    yPos += rowHeight + 4;
                }
            }

            pdf.save('georeferenciamento.pdf');
        } catch (e) {
            console.error(e);
        }

        btns.forEach(b => (b.style.display = ''));
        this.setState({ generatingPdf: false });
    };

    render() {
        const { type, selectedArea, showPdfButton } = this.props;

        const iconByType = {
            "Círculo": "fa-circle",
            "Círculo Manual": "fa-circle",
            "Polígono": "fa-draw-polygon",
            "Retângulo": "fa-square",
            "Empreendimento": "fa-building",
        };

        return (
            <div className="info-card area-info ov-hidden mt-mb-2">
                <hr className="info-card-hr hr-mapa" />

                {type.toLowerCase() != 'cidade' &&
                    <div className="info-card-header card-header">
                        <i className={`fa-solid ${iconByType[selectedArea.type] || ""}`} style={{ color: selectedArea.color }}></i>
                        {" "}{isNaN(selectedArea.name) ? selectedArea.name : `${type.split(' ')[0]} ${selectedArea.name}`}{" "}
                    </div>
                }

                <div className="card-body card-body-mapa-info">
                    <div className='font19'>
                        <span className="">Tipo da busca:</span> {selectedArea.type.toLowerCase()}
                    </div>

                    {selectedArea.radius !== undefined && (
                        <div className='font19'>
                            <span className="">Raio do círculo:</span> {Number(selectedArea.radius).toFixed(2)}
                        </div>
                    )}

                    <div className='font19'><span className="info-card-label">Total de usuários:</span> {selectedArea?.users?.length}</div>
                    <div className='font19'><span className="info-card-label">Total de empreendimentos:</span> {selectedArea?.buildings?.length}</div>

                    {showPdfButton && (
                        <button
                            className="btn-pdf-download"
                            onClick={this.downloadPDF}
                            disabled={this.state.generatingPdf}
                            style={{
                                marginTop: '8px',
                                backgroundColor: '#CF3C3E',
                                color: '#FFFFFF',
                                border: 'none',
                                borderRadius: '0',
                                padding: '8px 18px',
                                fontFamily: '"Archivo Expanded", Arial, sans-serif',
                                fontWeight: '600',
                                fontSize: '17px',
                                cursor: this.state.generatingPdf ? 'wait' : 'pointer',
                                opacity: this.state.generatingPdf ? 0.7 : 1,
                            }}
                        >
                            {this.state.generatingPdf ? 'Gerando...' : 'PDF'}
                        </button>
                    )}
                </div>
                <hr className="info-card-hr hr-mapa" />
            </div>
        );
    }
}

export default InfoCard;
